@if (type.includes("button")) {
  <div>
    <app-button
      (clicked)="!loading && exportXLSX()"
      labelPath="misc.export"
      type="filled"
      [rounded]="true"
      iconRight="download"
      [loading]="loading"
      [disabled]="disabled"
      data-tracking-id="button-export-excel"
    ></app-button>
  </div>
}
@if (type.includes("icon") && !loading) {
  <img
    [ngClass]="'exportIcon ' + type"
    src="./assets/img/search/export@2x.png"
    data-tracking-id="icon-export-excel"
    (click)="exportXLSX(); $event.stopPropagation()"
  />
}
@if (type.includes("icon") && loading) {
  <div [ngClass]="'exportIcon ' + type">
    <span class="loader"></span>
  </div>
}
